import { ReactNode, useState, useEffect } from 'react';
import cn from 'classnames';
import useResponsive, { QUERIES } from '@creditflowresearch/uilib/hooks/useResponsive';
import IconHamburgerMenu from '@creditflowresearch/uilib/Icon/IconHamburgerMenu';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';

import styles from './styles.module.scss';

const RelatedData = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isTablet = useResponsive(QUERIES.TABLET);

  useEffect(() => {
    if (!isTablet) {
      setIsOpen(false);
    }
  }, [isTablet]);

  const openMenu = () => {
    setIsOpen(true);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className={ styles.relatedData }>
        <div
          onClick={ openMenu }
          className={ cn(styles.relatedDataMenu, {
            [styles.relatedDataMenuVisible]: isTablet,
          }) }
        >
          <IconHamburgerMenu className={ styles.relatedDataIcons } />
        </div>
        <div className={ cn(styles.relatedDataContent, {
            [styles.relatedDataContentFixed]: isTablet,
            [styles.relatedDataContentFixedVisible]: isOpen && isTablet,
          }) }
        >
          <div
            onClick={ closeMenu }
            className={ cn(styles.closeButton, {
              [styles.closeButtonVisible]: isTablet,
            }) }
          >
            <IconClose className={ styles.relatedDataIcons } />
          </div>
          { children }
        </div>
      </div>
      <div
        onClick={ closeMenu }
        className={ cn(styles.overlay, {
          [styles.overlayVisible]: isOpen && isTablet,
        }) }
      />
    </>
  );
};

export default RelatedData;
